var React = require('react');

function SocialTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28 8.557C27.117 8.949 26.168 9.213 25.172 9.332C26.189 8.723 26.97 7.758 27.337 6.608C26.386 7.172 25.332 7.582 24.21 7.803C23.313 6.846 22.032 6.248 20.616 6.248C17.437 6.248 15.101 9.214 15.819 12.293C11.728 12.088 8.1 10.128 5.671 7.149C4.381 9.362 5.002 12.257 7.194 13.723C6.388 13.697 5.628 13.476 4.965 13.107C4.911 15.388 6.546 17.522 8.914 17.997C8.221 18.185 7.462 18.229 6.69 18.081C7.316 20.037 9.134 21.46 11.29 21.5C9.22 23.123 6.612 23.848 4 23.54C6.179 24.937 8.768 25.752 11.548 25.752C20.69 25.752 25.855 18.031 25.543 11.106C26.505 10.411 27.34 9.544 28 8.557Z","fill":"#222222"}));
}

SocialTwitter.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = SocialTwitter;

SocialTwitter.default = SocialTwitter;
